import { ReactNode } from 'react';
import Button from '~/components/buttons/NewButton';
import IconButton from '~/components/buttons/NewIconButton';
import { useInvoicePreviewModal } from '~/hooks/useInvoicePreviewModal';
import PreviewIcon from '~/icons/icon-document-preview.svg?react';
import { Document } from '~/types/document';

interface Props {
  children?: ReactNode;
  document: Document;
}

const DocumentPreviewDialogLink: React.FC<Props> = ({ children, document }) => {
  const showModal = useInvoicePreviewModal();

  const onPreviewOpen = () => {
    showModal({ document });
  };

  if (children) {
    return (
      <Button Icon={PreviewIcon} onClick={() => onPreviewOpen()} variant="ghost" size="small">
        {children}
      </Button>
    );
  } else {
    return <IconButton onClick={() => onPreviewOpen()} size="small" Icon={PreviewIcon} variant="ghost" />;
  }
};

export default DocumentPreviewDialogLink;
